import { StaffListPage } from '../staff/StaffListPage';

const Support = () => (
	<StaffListPage
		title="Suporte"
		description="Contas de suporte com acesso operacional ao painel."
		staffType="SUPPORT"
	/>
);

export { Support };
